import React, { useState } from "react";
import { Input, Select, DatePicker } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const VacationsFilterBar = ({ filters, onChange }) => {
  const update = (patch) => onChange({ ...filters, ...patch, pageNumber: 1 });
const [fromDate, setFromDate] = useState(null);

  return (
    <div className="flex flex-wrap gap-3 mb-6">
      <Input
        placeholder="Search doctor name..."
        prefix={<SearchOutlined className="text-gray-400" />}
        value={filters.searchDoctorName}
        onChange={(e) => update({ searchDoctorName: e.target.value })}
        size="large"
        allowClear
        style={{ maxWidth: 260, borderRadius: 10 }}
      />

      <Select
        placeholder="Status"
        value={filters.status}
        onChange={(v) => update({ status: v })}
        size="large"
        allowClear
        style={{ width: 140 }}
      >
        <Select.Option value={0}>Pending</Select.Option>
        <Select.Option value={1}>Approved</Select.Option>
        <Select.Option value={2}>Rejected</Select.Option>
      </Select>

  <DatePicker
  size="large"
  placeholder="From Date"
  style={{ borderRadius: 10 }}
  onChange={(date) =>
    update({ fromDate: date?.toISOString() || null })
  }
/>

<DatePicker
  size="large"
  placeholder="To Date"
  style={{ borderRadius: 10 }}
  onChange={(date) =>
    update({ toDate: date?.toISOString() || null })
  }
  disabledDate={(current) =>
    current && current < dayjs(fromDate).startOf("day")
  }
/>
    </div>
  );
};

export default VacationsFilterBar;